var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconContactDataTypes01 = function SvgIconContactDataTypes01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_contact_data_types-01_svg2__a",
    x1: 14.04,
    x2: 96.51,
    y1: 53.03,
    y2: 105.88,
    gradientTransform: "matrix(1 0 0 -1 0 102)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_contact_data_types-01_svg2__a",
    id: "icon_contact_data_types-01_svg2__b",
    x1: -1.92,
    x2: 14.07,
    y1: 74.84,
    y2: 85.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_contact_data_types-01_svg2__a",
    id: "icon_contact_data_types-01_svg2__c",
    x1: -1.79,
    x2: 14.05,
    y1: 46.8,
    y2: 56.94
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_contact_data_types-01_svg2__a",
    id: "icon_contact_data_types-01_svg2__d",
    x1: -1.77,
    x2: 14.07,
    y1: 18.7,
    y2: 28.84
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_contact_data_types-01_svg2__a",
    id: "icon_contact_data_types-01_svg2__e",
    x1: 13.75,
    x2: 102.91,
    y1: 22.69,
    y2: 79.89
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_contact_data_types-01_svg2__a",
    id: "icon_contact_data_types-01_svg2__f",
    x1: 15.03,
    x2: 74.22,
    y1: 4.49,
    y2: 42.4
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M25.07 28.14h62.44c3.45 0 6.24-2.8 6.24-6.24s-2.8-6.24-6.24-6.24H25.07c-3.45 0-6.24 2.8-6.24 6.24s2.8 6.24 6.24 6.24",
    style: {
      fill: "url(#icon_contact_data_types-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.95 17.5c-1.2 1.2-1.9 2.74-1.9 4.39v1.2c.05.4.2.8.35 1.2.15.35.35.75.6 1.05.2.35.5.7.8.95.3.3.6.55.95.75q.525.375 1.05.6c.4.2.85.35 1.3.45h1.2c1.65 0 3.25-.65 4.4-1.8.3-.3.55-.6.8-.95s.45-.7.6-1.05q.3-.6.45-1.2v-1.2c0-1.65-.65-3.25-1.85-4.4a6.266 6.266 0 0 0-8.79 0h.05Z",
    style: {
      fill: "url(#icon_contact_data_types-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.49 46.52c-.2-.35-.5-.65-.8-.95a6.266 6.266 0 0 0-8.79 0C.75 46.72.05 48.32.05 49.97c0 .8.15 1.65.45 2.4.15.35.35.7.55 1.05.25.35.5.65.8.95s.6.55.95.8.7.45 1.05.6c.4.15.8.3 1.2.35.4.1.8.15 1.2.1h1.2c.4-.05.8-.2 1.15-.35.4-.15.75-.35 1.1-.6.35-.2.65-.5.95-.8s.55-.6.8-.95q.375-.525.6-1.05c.2-.4.35-.85.45-1.3v-2.4c-.1-.4-.25-.8-.45-1.15-.15-.4-.35-.75-.6-1.1h.05Z",
    style: {
      fill: "url(#icon_contact_data_types-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.49 74.64c-.2-.35-.5-.65-.8-.95a6.266 6.266 0 0 0-8.79 0c-.3.3-.55.6-.8.95q-.375.525-.6 1.05c-.15.4-.3.8-.35 1.2q-.15.6-.15 1.2c0 1.65.65 3.25 1.85 4.4.3.3.6.55.95.8q.525.375 1.05.6c.4.15.8.3 1.2.35.4.1.8.15 1.2.1h1.2c.4-.05.8-.2 1.15-.35.4-.15.75-.35 1.1-.6.35-.2.65-.5.95-.8s.55-.6.8-.95q.375-.525.6-1.05c.2-.4.35-.85.45-1.3v-2.4q-.15-.6-.45-1.2c-.15-.35-.35-.75-.6-1.05h.05Z",
    style: {
      fill: "url(#icon_contact_data_types-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.71 43.77H25.07c-3.45 0-6.24 2.8-6.24 6.24s2.8 6.24 6.24 6.24h68.68c3.45 0 6.24-2.8 6.24-6.24s-2.8-6.24-6.24-6.24h-.05Z",
    style: {
      fill: "url(#icon_contact_data_types-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.63 71.84H25.07c-3.45 0-6.24 2.8-6.24 6.24s2.8 6.24 6.24 6.24h40.56c3.45 0 6.24-2.8 6.24-6.24s-2.8-6.24-6.24-6.24",
    style: {
      fill: "url(#icon_contact_data_types-01_svg2__f)"
    }
  }));
};
export default SvgIconContactDataTypes01;